import React from 'react';
import GameTile from './GameTile';

/* .csn_div is the inline-table grid; each .csn_thumb is 16.6667% wide → 6 columns. */
export default function GameGrid({ games }) {
  return (
    <div className="csn_div">
      {games.map((game, i) => (
        <GameTile key={`${game.name}-${i}`} game={game} />
      ))}
    </div>
  );
}
